module.exports = __webpack_public_path__ + "f1261375b23df9012801cc635e428b54.svg";